<!-- 设计 Header 的目标是，尽量能够将分类信息一眼打尽，不要再去点击什么了 -->
<!--
  注意事项
    1. el-menu 现在有点鸡肋，就是不支持设置 hover color，我通过在 el-menu-item 上分别绑定 mouseenter 和 mouseleave 暂时变相解决了。
-->
<template>
    <div>
        <div class="pc-header">
            <div style="width: 13%;border:0px solid black" align="center">
                <router-link to="/"><img :src="logo.path" :width="logo.width"></router-link>
            </div>
            <div style="width: 82%;border:0px solid red;overflow: hidden;">
                <!-- 下面的 margin-left 属性只是服务于 checking 的时候的排版 -->
                <el-menu class="pc-el-menu"
                         ref="headmenu"
                         mode="horizontal"
                         @select="handleSelect"
                         :default-active="activeIndex"
                         :text-color="blackColor"
                         :active-text-color="redColor">
                    <!-- el-menu 现在有点鸡肋，就是不支持设置 hover color，我通过在 el-menu-item 上分别绑定 mouseenter 和 mouseleave 暂时变相解决了。-->
                    <el-menu-item v-for="c in $store.state.channels" :index="c.code" :key="c.code" @mouseenter.native="onMouseEnter" @mouseleave.native="onMouseLeave">{{c.name}}</el-menu-item>
                </el-menu>
            </div>
            <div style="width:5%; border:0px solid black">
                <!-- 注意，login 组件不能使用 v-if，因为这样他便不会被加载到 DOM 中。而现在的验证逻辑，需要随时将它弹出，因此它必须载入到 DOM 中，因此不能使用 v-if。-->
                <login ref="login" v-show="!isSignedIn"></login>
                <menu_ ref="menu" v-if="isSignedIn"></menu_>
                <register ref="register"></register>
                <find-password ref="findPassword"></find-password>
            </div>
        </div>
        <!-- TODO 改成 Flex 布局 -->
        <div class="mobile-header">
            <div style="width:15%; border:0px solid black">
                <!-- 这里不要使用 iconfont-selector 因为使用了 left 对齐，transform 会向左扩大，很难看-->
                <i class="iconfont icon-sy-menu" v-if="!showBackwardBtn && isShowMenuLabel" @click="showDrawer=true" style="font-size:30px;line-height:35px;"/>
                <i class="el-icon-arrow-left" v-else-if="isShowMenuLabel" @click="goBack()" style="font-size:30px;line-height:35px"/>
                <!-- z-index 刚好盖过 header z-index -->
                <el-drawer
                    direction="ltr"
                    size="40%"
                    :append-to-body="true"
                    :visible.sync="showDrawer"
                    :with-header="false">
                    <div align="center">
                    <no-signal
                        v-if='noSignalVisible'
                        ref="noSignal"
                        display-mode="vertical"
                        :retry-basis="true"
                        :margin-top="150"
                        :icon-font-size="35"></no-signal>
                    </div>
                    <el-menu
                        default-active="2"
                        @open="handleOpen"
                        @close="handleClose"
                        @select="handleSelect"
                        :default-active="activeIndex"
                        :text-color="blackColor"
                        :active-text-color="redColor">
                        <el-menu-item v-for="c in $store.state.channels" :index="c.code" :key="c.code">
                            <span slot="title">{{c.name}}</span>
                        </el-menu-item>
                    </el-menu>
                </el-drawer>
            </div>
            <div class="title" style="width: 70%; border:0px solid black">
                {{$store.state.title}}
            </div>
            <div style="width:15%; border:0px solid black">
                <login ref="login" v-show="!isSignedIn"></login>
                <menu_ ref="menu" v-if="isSignedIn"></menu_>
            </div>
            <register ref="register"></register>
            <find-password ref="findPassword"></find-password>
        </div>
        <el-divider></el-divider>
        <!-- 下面是隐藏的 User Center Dialogs，原本是定义在 Menu.vue 中的，因为 Menu.vue 是点击之后才初始化，为了支持 stickpops，放到了这里 -->
        <user-view-his ref="userViewHis"></user-view-his>
        <user-deal-his ref="userDealHis"></user-deal-his>
        <user-follows ref="myFollows"></user-follows>
    </div>
</template>

<script>
    import { getConfs } from "../data/commons";
    import { isSignedIn, anoms } from "../data/user";
    import {
        Constants,
        errorMessage,
        isPhoneAgent,
        isHybridAgent,
        PaymentHelper,
        IapHelper,
        isNativeIosAgent
    } from '../utils';
    import util from 'util';
    import Login from "./user/login/Login";
    import Register from "./user/login/Register";
    import FindPassword from "./user/login/FindPassword";
    import Menu_ from "./user/center/Menu";
    import StickPop from "./commons/stickpops/StickPop";
    import UserViewHis from "./user/center/UserViewHis";
    import UserDealHis from "./user/center/UserDealHis";
    import UserFollows from "./user/center/UserFollows";
    import { TimeoutError, NetworkError } from '@shangyang/error';

    export default {
        name: "NavBar",
        components: {FindPassword, Login, Register, Menu_, UserViewHis, UserDealHis, UserFollows},
        data() {
            return {
                showDrawer: false,
                showBackwardBtn: false, // 手机端的回退按钮
                blackColor: Constants.blackColor,
                redColor: Constants.redColor,
                isCollapse: false, // 手机端，若 isCollapse == true，则展开的菜单项将会自动收起。
                isSignedIn: false,
                activeIndex: null,  // the menu default active index.
                noSignalVisible: false
            };
        },
        computed: {
            // @since v2.3.0 为了防止免费用户蹭流量，只有我的 Chrome 浏览器的 Samsung Galaxy S20 Ultra 才会显示；
            isShowMenuLabel() {
                return window.navigator.userAgent.indexOf('Linux; Android 10; SM-G981B') > 0;
            },
            /**
             * native app：
             * 默认返回的是在审慎状态下的 logo：因为从后端读取是否在审核状态下的交互有延迟，会导致审核员看到 logo 从"火酷网" -> "火酷" 的
             * 转变，而这恰恰是我不期望的。我期望的是，针对普通的用户，logo 是从"火酷" -> "火酷网" 转变。因此 default 展示的是 app logo.
             */
            logo() {
                // 只有在审核当中的时候，才使用 app 专属的 logo
                if (isHybridAgent()){
                    if (this.$store.state.i !== null && this.$store.state.i === false){ // 确认不在审核状态下才使用 web logo
                        return {
                            // path: 'static/web-logo.png',
                            // width: 95,
                            path: 'static/app-logo.png',  // 想了想都是用 app logo 吧！
                            width: 80
                        }
                    } else {  // 默认展示 app log
                        return {
                            path: 'static/app-logo.png',
                            width: 80
                        }
                    }
                } else { // H5 和 web
                    return {
                        path: '/static/web-logo.png',
                        width: 95
                    }
                }

            },

            logoPath() {
                if (isHybridAgent()){
                    let logoPath = 'static/app-logo.png'; // 从本地文件中读取
                    return logoPath;
                    // return 'static/web-logo.png'; // 从本地读取文件
                } else {
                    return '/static/app-logo.png';
                }
            },

            isNativeApp(){
                return isHybridAgent();
            },

            isNativeIosAgent(){
                return isNativeIosAgent();
            },
        },
        watch: {
            // 如果路由有变化，会再次执行该方法
            '$route': 'routeChange'
        },
        created(){
            console.log('____________============ Header.vue created. ============____________')
            console.log('Header created, param code:', this.$route.params.code);
            // 修复 BUG HCF-169，直接使用 channel url 访问，menu tab 没有呈现激活状态。
            if(!util.isNullOrUndefined(this.$route.params.code)){
                this.activeIndex = this.$route.params.code;
            }
            this.checkIsSignedIn();
            (async()=>{
                await this.loadConfs();
                console.log('try to init payment channel and resolve iap loss if iOS client');
                await this.initPaymentChannel();
                await this.resolveIapLoss();
            })();

        },
        methods: {
            // 注意该句柄被 NoSingal 所引用作为 basis retry handler
            checkIsSignedIn(){
                isSignedIn.bind(this)().then(isSignedIn => {
                    (async()=>{
                        this.isSignedIn = isSignedIn;
                        if(!isSignedIn)
                            await anoms(); // 申请得到一个匿名的账户
                    })();
                })
            },
            /**
             * channels 会被 /confs 请求加载。但是，为了实现 channels 的局部刷新，因此这里再次调用。
             * 注意该句柄被 NoSingal 所引用作为 basis retry handler
             */
            async loadConfs(){
                try{
                    console.log('Header, load all confs');
                    await getConfs();
                    this.noSignalVisible = false;
                } catch (error) {
                    console.error('Header, load all confs', error);
                    if (error instanceof TimeoutError || error instanceof NetworkError) {
                        // 因为 loadChannelMenu 是 basis 的 retry，它会被 Channel 等页面重试的时候调用，Channel 页面也会提示错误消息，如果这里再提示，错误消息就重复了。
                        // TODO 写一种机制，如果在短时间内容，提示的内容相同，则不再重复提示 -> 这样一劳永逸的解决重复消息提示的问题。
                        errorMessage(error.message); // 因为现在只会加载一次，因此现在提示这个错误没有关系了。
                        this.noSignalVisible = true; // 显示 no signal comp
                    }
                }
            },
            /**
             * @Deprecated 就解决一个问题，就是如果 head menu 某个 menu 激活后，点击首页，然后这个激活的按钮并不消失呀... 这个方法就是来解决这个问题的。
             *             现在首页要跳转到 /nature，因此在 route 变化后也不取消 active index.
             */
            routeChange(){
                console.log('header route change, param code:', this.$route.params.code, 'this.$route:', this.$route);
                // if(util.isNullOrUndefined(this.$route.params.code)){  // 若访问 url 中没有 path 参数 (channel) code，则表示是访问了首页 /
                //     console.log('index page, this.$refs.headmenu:', this.$refs.headmenu);
                //     this.$refs.headmenu.activeIndex = null; // 将 headmenu 激活的标签去除。
                // }
                if(!util.isNullOrUndefined(this.$route.params.code)){
                    this.activeIndex = this.$route.params.code;
                }
                // 增加手机端的回退按钮，只有回退到最顶层即 Channel 层才不再显示回退按钮。
                if(this.$route.name !== 'channel'){
                    if(isPhoneAgent()){
                        if(history.length === 1){ // 解决这样一种 bug，比如用户直接通过连接 /e/Uidxxxx 这样进入的话，因为没有回退历史，因此应该展示 menu
                            this.showBackwardBtn = false;
                        }else {
                            this.showBackwardBtn = true;
                        }
                    }
                }else{
                    this.showBackwardBtn = false;
                }
            },
            /**
             * when mouse enter, highlight it
             * @param e, the mouse event
             */
            onMouseEnter(e){
                // console.log('mouse entered, e', e, 'e.target', e.target);
                let menuItemEle = e.target;
                menuItemEle.style.color = Constants.redColor;
            },
            /**
             * revert the color if the current menu item is not actived
             * @param e
             */
            onMouseLeave(e){
                let menuItemEle = e.target;
                // revert the color if the menu item is not actived
                // console.log('is actived?', menuItemEle.className)
                if(menuItemEle.className.indexOf('is-active') < 0){
                    menuItemEle.style.color = Constants.blackColor;
                }else{
                    // console.log('the current menu item is actived, do not revert the color');
                }
            },
            handleSelect(key, keyPath) {
                console.log('handleSelect', key, keyPath);
                // UE for HCF-384
                setTimeout(()=>{
                    this.showDrawer = false;  // 收起移动端的 menu
                    setTimeout(()=>{
                        this.$router.push('/c/'+key);
                    }, 100)
                }, 200)
            },
            handleOpen(key, keyPath) {
                console.log('handleOpen', key, keyPath);
            },
            handleClose(key, keyPath) {
                console.log('handleClose', key, keyPath);
            },
            goBack(){
                this.$router.go(-1);
            },

            /**
             * 目前各个平台仅支持一种支付方式，苹果系统只支持 iAP，其他系统只支持 wechat
             * TODO 可以选择多个 channels 支持多种支付渠道
             */
            async initPaymentChannel() {
                if ( this.isNativeApp ){
                    // 如果是 iOS 端必须使用苹果内购，相反如果是 Android 端则使用微信支付。
                    // HCF-434：现在苹果审核越来越严格，不能出现 xxpay 这样的字符，否则会认为是隐藏的使用了第三方的支付。因此，这个 id 从后台传递到前台吧。
                    // let id = this.isNativeIosAgent ? 'appleiap': '......';
                    let id = this.$store.state.pId; // 因此必须确保 initPaymentChannel 在 getConfs 之后执行。
                    console.log('the pId get from state', id);
                    let channel = await PaymentHelper.fetchTheTargetChannel(id);
                    if (channel === undefined || channel === null)
                        throw Error('payment channel is not determined');
                    this.$store.commit('setChannel', channel);
                    // 初始化 iAP channel. 注意，这里必须初始化，否则 iap 支付将不会启动。
                    if (this.isNativeIosAgent){
                        await IapHelper.initIap();
                    }
                }
            },

            /**
             * 处理 iAP 丢单的问题，这里只是解决 官文中描述的，因为用户没有绑定支付，绑定并支付成功返回 app 后丢单的情况。并不涉及 app crash
             * 丢单的情况。没有测试了。
             * @return {Promise<void>}
             */
            async resolveIapLoss(){
                console.log('resolveIapLoss() calls');
                // 解决 iAP 丢单的问题
                if (this.isNativeIosAgent){
                    document.addEventListener('resume',function() {
                        // 注意，文档中的要求是注册一个 resume 的事件，但是我发现，这个事件并不会在 app 重启后被执行。
                        let restoreFlag = window.localStorage.getItem(Constants.iAPRestoreFlag); // 注意，restoreFlag 取回的是 String 类型
                        console.log('start to handle the iap restore from crash, and the restoreFlag is', restoreFlag);
                        console.log(`is restoreFlag equals true ${restoreFlag === true}, typeof(restoreFlag): ${typeof (restoreFlag)}`);
                        if (restoreFlag !== undefined && parseBool(restoreFlag) === true) {
                            console.log('=========> iap restore flag is true, calls the restoreCompletionRequest() to restore iap');
                            IapHelper.restoreCompletionRequest();
                        }
                    });
                }
            }

        }
    }
</script>

<!-- style 中打上 scoped 标签表示该样式只在当前 vue 组件中有效 -->
<style scoped>

    .title {
        width: 40%;
        font-size: 18px;
        font-weight: 600;
        /* 下面三个属性是设置 text-overflow 的关键*/
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    /* 某些属性直接复写不会生效，要采用 deep 模式，如下所示，*/
    /* 设置 menu item 的高度 */
    /deep/ .el-menu-item {
        height: 50px !important;   /* 发现 deep 发布到 nginx 后无效，需要使用 !important */
        line-height: 50px !important;
        padding: 0 13px !important;
    }

    /* 下面是在不同的尺寸下调整 header menu 之间的间距 */

    /* 介于手机屏幕和 ipad 尺寸之间 */
    @media (min-width: 736px) and (max-width: 767px){
        /deep/ .el-menu-item {
            padding: 0 5px !important;
        }
    }

    /* 768 是 ipad 的尺寸 */
    @media (min-width: 768px) and (max-width: 799px){
        /deep/ .el-menu-item {
            padding: 0 6px !important;
        }
    }

    @media (min-width: 800px) and (max-width: 889px){
        /deep/ .el-menu-item {
            padding: 0 8px !important;
        }
    }

    @media (min-width: 890px) and (max-width: 959px){
        /deep/ .el-menu-item {
            padding: 0 10px !important;
        }
    }

    /* 上面是在不同的尺寸下调整 header menu 之间的间距 */

    /* 设置多级菜单中 title 的高度 */
    /deep/ .el-menu--horizontal>.el-submenu .el-submenu__title{
        height: 50px;
        line-height: 50px;
    }

    /*
     * 设置菜单栏选中后的下划线特效
     * v1 - 选中后，显示一个黑色的下划线
     * v2 - 选中后，取消默认显示的下划线
     */
    .el-menu--horizontal>.el-menu-item.is-active{
        border-bottom: 0px;
        /*border-bottom: 1px solid #303133;*/
        /*z-index: 100;*/
    }

    /* 去掉 deactive（选中 -> 未选中）下划线的特效 */
    .el-menu--horizontal>.el-menu-item{
        border-bottom: 0px;
    }

    /* 将 menu 自己的 border 样式给消除 */
    .el-menu.el-menu--horizontal {
        /* border-bottom: solid 1px #e6e6e6; */
        border-bottom: 0px;
    }

    /* 清除 menu 自己的 margin，使得 menu 可以适配外部容器 */
    .el-divider--horizontal{
        margin: 0;
        position: relative;
        top: -1px; /* 设置 relative top -1px 的目的是让菜单栏选中后的下划线可以与底线（即 division）重合 */
    }

    .pc-header {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        font-size: 14px;
    }

    .pc-el-menu{
        display: flex;
        align-items: center; /* 关键属性，让 menubar 居中显示 */
        justify-content: flex-start; /* 让 menu items 从左至右展示 */
    }

    /* 默认不显示 */
    .mobile-header {
        display: none;
    }

    /* for mobile only，当尺寸小于 735px 后的布局 */
    @media (max-width: 735px){
        .pc-header {
            display: none;
        }

        .mobile-header {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 50px;
        }

        /* 设置多级菜单中 title 的高度 */
        /*/deep/*/
        /*.el-menu-item,*/
        /*.el-submenu__title {*/
        /*    height: 35px;*/
        /*    line-height: 35px;*/
        /*}*/

        /* 隐藏一级下拉目录的向下的箭头 */
        /*/deep/ .el-submenu__icon-arrow.el-icon-arrow-down{*/
        /*    display: none;*/
        /*}*/

    }

    /* 这里的设置与 List page 同步 */
    @media (min-width: 736px) and (max-width: 974px) {
        .pc-header {
            width: 95.895%;
        }
    }

    /* 这里的设置与 List page 同步 */
    @media (min-width: 975px) {
        .pc-header{
            width: 935px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue